import React, { Component } from "react";

import Intro from "../../components/GlobalSections/Intro/Intro";
import Message from "../../components/GlobalSections/Message/Message";
import LargePhoto from "../../components/UI/LargePhoto/LargePhoto";
import image from "../../assets/images/global-group--resized.jpg";
import GlobalStats from '../../components/GlobalSections/GlobalStats/GlobalStats'
import AbroadPrograms from '../../components/GlobalSections/AbroadPrograms/AbroadPrograms'

import NextPage from "../../components/UI/NextPage/NextPage";
import { Helmet } from "react-helmet";

class GlobalOpportunities extends Component {
  componentDidMount() {
    try {
      window.scroll({
        top: 0,
        left: 0,
      });
    } catch (error) {
      window.scrollTo(0, 0);
    }
  }
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Dickinson Viewbook | Our Global Oppotunities</title>
        </Helmet>
        <Intro />
        <Message />
        <LargePhoto src={image} alt="Students on a student abroad program" />
        <GlobalStats />
        <AbroadPrograms />
        <NextPage
          link="/sustainable-leadership"
          title="Our Sustainable Leadership"
        />
      </React.Fragment>
    );
  }
}

export default GlobalOpportunities;
